module.exports = __webpack_public_path__ + "files/784cb94e8e15e016ca1d267409bfc0b0.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/word.png
// module id = 497
// module chunks = 60